import { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  createTheme,
  Box,
  Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import SelectLevel from '../SelectLevel';
import ViewExamsList from './ViewExamsList';
import { useFetch } from '../../hooks/useFetch';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import AddIcon from '@mui/icons-material/Add';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { useAuthContext } from '../../hooks/useAuthContext';
function RemoveExamAuth({
  removeId,
  handleComplete,
  setRemoveExam,
  studentId,
}) {
  const {
    error,
    isPending,
    data: examData,
  } = useFetch(
    `https://pcapi.bi-oss.co.za/studcambridge/authbyid/${removeId}`,
    'GET',
  );
  const {
    updateData,
    error: error2,
    errorMessage: errorMessage2,
    isPending: isPending2,
    data: examAuthurised,
  } = useFetch(
    `https://pcapi.bi-oss.co.za/studcambridge/authbyid/removeconf/${removeId}`,
    'PUT',
  );

  const [succ, setSucc] = useState(0);
  const { user } = useAuthContext();

  const handleSubmit = (e) => {
    e.preventDefault();
    updateData({
      removeId,
      createdBy: user.email,
      studentId,
    });
  };

  useEffect(() => {
    if (examAuthurised) {
      setSucc(1);
    }
  }, [examAuthurised]);

  return (
    <>
      {isPending2 && (
        <Container maxWidth="md">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography variant="h6" component="h3" color="primary.main">
                  Removing examination from cart...
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      )}

      {error2 && !errorMessage2 && (
        <Container maxWidth="md">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'error.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography variant="h6" component="h3" color="primary.main">
                  {error2}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Button
                      color="error"
                      fullWidth
                      type="button"
                      variant="contained"
                      onClick={(e) => handleComplete()}
                    >
                      View Cart
                      <ShoppingCartIcon />
                    </Button>
                  </Box>
                  <Box mb={5} />
                </Grid>
              </Box>
              <Box mb={5} />
            </Grid>
          </Grid>
        </Container>
      )}
      {errorMessage2 && (
        <Container maxWidth="md">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'error.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography
                  variant="h3"
                  component="h3"
                  color="error.main"
                  sx={{ textAlign: 'center' }}
                >
                  Remove Exam from Cart
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Typography variant="h6" component="h3" color="error.main">
                  {errorMessage2}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Button
                      color="error"
                      fullWidth
                      type="button"
                      variant="contained"
                      onClick={(e) => handleComplete()}
                    >
                      View Cart
                      <ShoppingCartIcon />
                    </Button>
                  </Box>
                  <Box mb={5} />
                </Grid>
              </Box>
              <Box mb={5} />
            </Grid>
          </Grid>
        </Container>
      )}
      {isPending && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />

            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography variant="h6" component="h3" color="primary.main">
                    Fetching examination details...
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </>
      )}

      {examData &&
        examData.length > 0 &&
        !succ &&
        !isPending2 &&
        !errorMessage2 &&
        !error2 &&
        examData.map((data) => (
          <>
            <Container maxWidth="md">
              <form onSubmit={handleSubmit}>
                <Box mb={5} />

                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                  sx={{
                    border: 'solid',
                    borderWidth: '3px',
                    borderColor: 'error.main',
                    borderRadius: 2,
                  }}
                >
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="h3"
                        component="h3"
                        color="error.main"
                        sx={{ textAlign: 'center' }}
                      >
                        Remove from Cart
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography
                        variant="body2"
                        component="p"
                        color="error.main"
                        sx={{ textAlign: 'center' }}
                      >
                        Do you wish to remove the below examination paper
                        combination from your exam cart?
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <TextField
                        id="otp"
                        label="Qualification:"
                        variant="outlined"
                        required
                        value={data.qualification}
                        fullWidth
                        autoFocus
                        inputProps={{ style: { textAlign: 'center' } }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <TextField
                        id="otp"
                        label="Course Code:"
                        variant="outlined"
                        required
                        value={data.camCode}
                        fullWidth
                        autoFocus
                        inputProps={{ style: { textAlign: 'center' } }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <TextField
                        id="otp"
                        label="Paper Combination:"
                        variant="outlined"
                        required
                        value={data.paperCode}
                        fullWidth
                        autoFocus
                        inputProps={{ style: { textAlign: 'center' } }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <TextField
                        id="otp"
                        label="Paper Description:"
                        variant="outlined"
                        required
                        value={data.description}
                        fullWidth
                        autoFocus
                        inputProps={{ style: { textAlign: 'center' } }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      {!isPending2 && (
                        <Button
                          fullWidth
                          color={'primary'}
                          variant="contained"
                          onClick={(e) => setRemoveExam(0)}
                        >
                          Cancel
                        </Button>
                      )}

                      {isPending2 && (
                        <Button
                          fullWidth
                          color={'primary'}
                          variant="contained"
                          disabled
                        >
                          Cancel
                        </Button>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      {!isPending2 && (
                        <Button
                          fullWidth
                          color={'error'}
                          variant="contained"
                          type="submit"
                        >
                          Remove
                        </Button>
                      )}
                      {isPending2 && (
                        <Button
                          fullWidth
                          color={'error'}
                          variant="contained"
                          disabled
                        >
                          Remove
                          <CircularProgress />
                        </Button>
                      )}
                    </Box>
                    <Box mb={5} />
                  </Grid>
                </Grid>
              </form>
            </Container>
          </>
        ))}

      {!isPending2 && !error2 && !errorMessage2 && succ === 1 && (
        <>
          <Box mb={5} />
          <Container maxWidth="md">
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'success.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography
                    variant="h6"
                    component="h3"
                    padding={1}
                    borderRadius={1}
                    color="success.main"
                  >
                    Examination Removed
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography
                    variant="body2"
                    component="p"
                    padding={1}
                    borderRadius={1}
                    color="success.main"
                  >
                    The selected examination paper combination has been removed
                    from your exam cart.
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Button
                        color="success"
                        fullWidth
                        type="button"
                        variant="contained"
                        onClick={(e) => handleComplete()}
                      >
                        View Cart
                        <ShoppingCartIcon />
                      </Button>
                    </Box>
                  </Grid>
                </Box>
                <Box mb={5} />
              </Grid>
            </Grid>
            <Box mb={4} />
          </Container>
        </>
      )}
    </>
  );
}

export default RemoveExamAuth;
